import React, { useState } from "react";
import chevronDown from "../../assets/icons/Chevron-down.svg";
import warningIcon from "../../assets/icons/Warning-default.svg";
import { InfoCircleFill } from "react-bootstrap-icons";

const ReusableAccordion = ({
  sectionTitle,
  children,
  defaultOpen = false,
  className,
  errorMessage,
  hasValidationErrors,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section className={`clinical-accordion ${className}`}>
      <button
        type="button"
        className="clinical-accordion-header"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <div className="d-flex flex-column w-100">
          <div className="title-icon-wrapper">
            <span>{sectionTitle}</span>
            {hasValidationErrors && (
              <img src={warningIcon} alt="warning icon" />
            )}
          </div>
          {errorMessage && (
            <div className="invalid-feedback">
              <InfoCircleFill />
              {errorMessage}
            </div>
          )}
        </div>
        <span
          aria-hidden="true"
          className={`accordion-chevron ${isOpen ? "open" : ""}`}
        >
          <img src={chevronDown} alt="" />
        </span>
      </button>

      {isOpen && <div className="clinical-accordion-content">{children}</div>}
    </section>
  );
};

export default ReusableAccordion;
